export class EmailDto {
    email:string;
    emailprofile:string;
    subject:string;
    name:string;
    locations:string;
    textbody:string;
    phone:string;
}
